import {AlertingAction} from "../entities/AlertingAction";
import {BaseService} from "./BaseService";
import { StateService } from "@uirouter/angularjs";

export class AlertingActionService extends BaseService<AlertingAction>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, AlertingAction);
    }
    protected getBaseUrl():string{
        return "alertingaction";
    }
}
